import {ResolveFn, Router} from '@angular/router';
import {UserService} from "../Services/user.service";
import {inject} from "@angular/core";
import {catchError, tap} from "rxjs/operators";
import {of} from "rxjs";
import {User} from "../Models/user.model";

export const userResolver: ResolveFn<User | undefined> = (activatedRoute, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const userId = Number(activatedRoute.paramMap.get("id"));

  return userService.getItzById(userId).pipe(
    tap((user: User | undefined) => {
      if (!user) {
        router.navigate(['Dashboard']);
      }
    }),
    catchError(() => {
      router.navigate(['Dashboard']);
      return of(undefined);
    })
  );

};
